import React, { Component } from 'react';
import { connect } from 'react-redux';
import Dashboard from '../Dashboard';
import SectionHeader from '../elements/SectionHeader';
import ModuleHeader from '../elements/ModuleHeader';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import server from '../../../api/server';

export class PrioHosting extends Component {
    constructor(props) {
        super(props);

        this.state = {
            processing: false,
            currency: "USD"
        };
    }

    componentDidMount() {
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera


    }

    upgrade = async () => {
        this.setState({ processing: true });

        try {
            const response = await server.post('/dashboard/priority-hosting/checkout', {
            });



            if (response.data.url) {
                // For demo purposes - redirect to the loading screen component
                window.location.href = response.data.url;

                // In production, this would be where you redirect to Stripe
                // After successful Stripe payment, redirect back to the loading screen
                // window.location.href = response.data.url;
            } else {
                console.error('Failed to create checkout session:', response.data.error);
                this.setState({ processing: false });
            }
        } catch (error) {
            console.error('Error creating checkout session:', error);
            this.setState({ processing: false });
        }
    };

    render() {
        const stripePortalUrl = process.env.REACT_APP_STRIPE_PORTAL;

        const handleSubscriptionManagement = () => {
            window.location.href = stripePortalUrl;
        };

        const renderActionButton = () => {
            if (this.props.user.prio_hosting) {
                return (
                    <button
                        onClick={handleSubscriptionManagement}
                        className="w-full py-4 px-6 bg-gradient-to-r from-[#00ffe0] to-[#00ccb3] hover:from-[#00ffe0] hover:to-[#00d9c4] text-black font-medium rounded-md transition-all transform hover:-translate-y-1 hover:shadow-xl mb-4">
                        Manage Subscription
                    </button>
                );
            }
            return (
                <button
                    onClick={this.upgrade}
                    disabled={this.state.processing}
                    className="w-full py-4 px-6 bg-gradient-to-r from-[#00ffe0] to-[#00ccb3] hover:from-[#00ffe0] hover:to-[#00d9c4] text-black font-medium rounded-md transition-all transform hover:-translate-y-1 hover:shadow-xl mb-4 disabled:opacity-50 disabled:cursor-not-allowed">
                    {this.state.processing ? 'Processing...' : 'Upgrade Now'}
                </button>
            );
        };

        return (
            <Dashboard>
                <ToastContainer />

                {/* Module Header */}
                <ModuleHeader
                    title="Priority Hosting"
                    icon="priority hosting.png"
                    description="Upgrade ALL your bots to our exclusive high-performance servers with enhanced features and vip access to our community"
                    showEnabled={false}
                />

                {/* Main Container */}
                <div className="max-w-7xl mx-auto px-4 py-8">
                    {/* Hero Section - Two Column Layout */}
                    <div className="flex flex-col lg:flex-row gap-8 mb-16">
                        {/* Left Column - Description and Features */}
                        <div className="lg:w-3/5">
                            <div className="bg-gradient-to-br from-[#1E1E30] to-[#1F2D2B] rounded-xl p-8 h-full border border-[#00ffe0] shadow-lg">
                                <span className="text-[#00ffe0] text-sm font-medium tracking-wide uppercase">Premium Upgrade</span>
                                <h1 className="text-4xl font-bold text-white mt-3 mb-4">
                                    Priority Hosting
                                </h1>
                                <p className="text-[#E5E7EB] text-lg mb-6">
                                    Supercharge ALL your bots with enhanced performance, exclusive features, and VIP community access.
                                </p>

                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
                                    <div className="flex items-start">
                                        <div className="text-[#00ffe0] text-xl mr-3">⚡</div>
                                        <div>
                                            <h3 className="text-white font-medium">Exclusive Servers</h3>
                                            <p className="text-sm text-[#00ffe0]">~10 bots per pod vs. 1-2k</p>
                                        </div>
                                    </div>
                                    <div className="flex items-start">
                                        <div className="text-[#00ffe0] text-xl mr-3">💾</div>
                                        <div>
                                            <h3 className="text-white font-medium">365-Day Interactions</h3>
                                            <p className="text-sm text-[#00ffe0]">Extended button & menu storage</p>
                                        </div>
                                    </div>
                                    <div className="flex items-start">
                                        <div className="text-[#00ffe0] text-xl mr-3">🔬</div>
                                        <div>
                                            <h3 className="text-white font-medium">Alpha Access</h3>
                                            <p className="text-sm text-[#00ffe0]">Test new features first</p>
                                        </div>
                                    </div>
                                    <div className="flex items-start">
                                        <div className="text-[#00ffe0] text-xl mr-3">👑</div>
                                        <div>
                                            <h3 className="text-white font-medium">VIP Discord</h3>
                                            <p className="text-sm text-[#00ffe0]">Monthly Q&A & special role</p>
                                        </div>
                                    </div>
                                </div>

                                <div className="flex items-center gap-2 mt-8">
                                    <div className="text-[#00ffe0] text-sm flex items-center gap-1">
                                        <span className="w-4 h-4 inline-flex items-center justify-center bg-[#00ffe0] text-black rounded-full text-xs">✓</span>
                                        <span>Exclusive servers</span>
                                    </div>
                                    <div className="text-[#00ffe0] text-sm flex items-center gap-1">
                                        <span className="w-4 h-4 inline-flex items-center justify-center bg-[#00ffe0] text-black rounded-full text-xs">✓</span>
                                        <span>365-day interaction storage</span>
                                    </div>
                                    <div className="text-[#00ffe0] text-sm flex items-center gap-1">
                                        <span className="w-4 h-4 inline-flex items-center justify-center bg-[#00ffe0] text-black rounded-full text-xs">✓</span>
                                        <span>Alpha access</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Right Column - Pricing Card */}
                        <div className="lg:w-2/5">
                            <div className="bg-[#1A1A2E] rounded-xl p-8 border border-[#00ffe0] shadow-lg">
                                <div className="flex justify-between items-center mb-6">
                                    <div className="bg-[#00ffe0] text-black px-3 py-1 rounded-full text-xs font-bold">ALL BOTS</div>
                                    <div className="text-[#00ffe0] text-sm">One subscription</div>
                                </div>

                                <div className="mb-6">
                                    <div className="flex items-baseline">
                                        <span className="text-5xl font-bold text-white">
                                            {this.state.currency === "EURO" ? "€" : "$"}15
                                        </span>
                                        <span className="ml-2 text-sm text-[#00ffe0]">/month</span>
                                    </div>
                                </div>

                                <p className="text-sm mb-8 text-[#00ffe0]">
                                    Upgrade your entire bot fleet to our exclusive high-performance servers with enhanced features and VIP community access. Ideal for serious developers with bots in thousands of servers requiring enterprise-grade reliability.
                                </p>

                                {renderActionButton()}

                                <p className="text-xs text-center text-[#00ffe0]">
                                    Includes 7-day money-back guarantee
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* Main Features Section - Larger Cards */}
                    <div className="mb-16">
                        <SectionHeader title="Exclusive Benefits" pretitle="Priority Features" />
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-8">
                            {/* Performance Card */}
                            <div className="bg-gradient-to-br from-[#1A1A2E] to-[#1F2D2B] p-8 rounded-lg border border-[#00ffe0] shadow-md">
                                <div className="flex items-center mb-6">
                                    <div className="text-[#00ffe0] text-3xl mr-4">⚡</div>
                                    <h3 className="text-2xl font-bold text-white">Enhanced Performance</h3>
                                </div>
                                <p className="text-[#00ffe0] mb-4">
                                    Priority Hosting places your bots on our premium infrastructure, ensuring faster response times,
                                    increased reliability, and enhanced capabilities for all your Discord bots.
                                </p>
                                <ul className="space-y-4 text-[#E5E7EB]">
                                    <li className="flex items-start">
                                        <span className="text-[#00ffe0] text-lg mr-3">✓</span>
                                        <div>
                                            <span className="font-medium">Exclusive Server Pods</span>
                                            <p className="text-sm text-[#00ffe0] mt-1">Only ~10 bots per pod versus 1-2 thousand on standard hosting</p>
                                        </div>
                                    </li>
                                    <li className="flex items-start">
                                        <span className="text-[#00ffe0] text-lg mr-3">✓</span>
                                        <div>
                                            <span className="font-medium">Increased API Limits</span>
                                            <p className="text-sm text-[#00ffe0] mt-1">With advanced back-off functions and monitoring</p>
                                        </div>
                                    </li>
                                    <li className="flex items-start">
                                        <span className="text-[#00ffe0] text-lg mr-3">✓</span>
                                        <div>
                                            <span className="font-medium">Fast Update Process</span>
                                            <p className="text-sm text-[#00ffe0] mt-1">Less than 1 minute downtime vs. ~10 minutes for standard servers</p>
                                        </div>
                                    </li>
                                </ul>
                            </div>

                            {/* Community Card */}
                            <div className="bg-gradient-to-br from-[#1A1A2E] to-[#1F2D2B] p-8 rounded-lg border border-[#00ffe0] shadow-md">
                                <div className="flex items-center mb-6">
                                    <div className="text-[#00ffe0] text-3xl mr-4">👑</div>
                                    <h3 className="text-2xl font-bold text-white">Priority Community</h3>
                                </div>
                                <p className="text-[#00ffe0] mb-4">
                                    Join an exclusive community of premium users with direct access to our development team and special Discord privileges.
                                </p>
                                <ul className="space-y-4 text-[#E5E7EB]">
                                    <li className="flex items-start">
                                        <span className="text-[#00ffe0] text-lg mr-3">✓</span>
                                        <div>
                                            <span className="font-medium">VIP Discord Access</span>
                                            <p className="text-sm text-[#00ffe0] mt-1">Exclusive Priority Users section with special role</p>
                                        </div>
                                    </li>
                                    <li className="flex items-start">
                                        <span className="text-[#00ffe0] text-lg mr-3">✓</span>
                                        <div>
                                            <span className="font-medium">Developer Engagement</span>
                                            <p className="text-sm text-[#00ffe0] mt-1">Monthly Q&A sessions with Staff Team & Founder</p>
                                        </div>
                                    </li>
                                    <li className="flex items-start">
                                        <span className="text-[#00ffe0] text-lg mr-3">✓</span>
                                        <div>
                                            <span className="font-medium">Development Influence</span>
                                            <p className="text-sm text-[#00ffe0] mt-1">More sway over bug fixes and feature development</p>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    {/* Additional Features Section - Smaller Cards */}
                    <div className="mb-16">
                        <SectionHeader title="Additional Benefits" pretitle="More Features" />
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-8">
                            {/* Data Retention */}
                            <div className="bg-[#1A1A2E] p-6 rounded-lg border border-[#00ffe0] hover:border-[#00ffe0] transition-all">
                                <div className="text-[#00ffe0] text-2xl mb-4">💾</div>
                                <h3 className="text-xl font-bold text-white mb-2">Extended Interaction Storage</h3>
                                <p className="text-sm text-[#00ffe0] mb-4">All your button settings and select menu configurations remain active in the database for 365 days without use, compared to only 30 days for normal and free bots. No more expired buttons or menus!</p>
                                <div className="h-1 w-16 bg-gradient-to-r from-[#00ffe0] to-[#00ccb3]"></div>
                            </div>

                            {/* Alpha Access */}
                            <div className="bg-[#1A1A2E] p-6 rounded-lg border border-[#00ffe0] hover:border-[#00ffe0] transition-all">
                                <div className="text-[#00ffe0] text-2xl mb-4">🔬</div>
                                <h3 className="text-xl font-bold text-white mb-2">Alpha Access</h3>
                                <p className="text-sm text-[#00ffe0] mb-4">Test early features on alpha.botghost.com and have a say in how new features are implemented before public release.</p>
                                <div className="h-1 w-16 bg-gradient-to-r from-[#00ffe0] to-[#00ccb3]"></div>
                            </div>

                            {/* Updates & Communication */}
                            <div className="bg-[#1A1A2E] p-6 rounded-lg border border-[#00ffe0] hover:border-[#00ffe0] transition-all">
                                <div className="text-[#00ffe0] text-2xl mb-4">📢</div>
                                <h3 className="text-xl font-bold text-white mb-2">Insider Updates</h3>
                                <p className="text-sm text-[#00ffe0] mb-4">Monthly roadmap updates, exclusive downtime notification channel, and priority surveys.</p>
                                <div className="h-1 w-16 bg-gradient-to-r from-[#00ffe0] to-[#00ccb3]"></div>
                            </div>

                            {/* Discord Role */}
                            <div className="bg-[#1A1A2E] p-6 rounded-lg border border-[#00ffe0] hover:border-[#00ffe0] transition-all">
                                <div className="text-[#00ffe0] text-2xl mb-4">🎭</div>
                                <h3 className="text-xl font-bold text-white mb-2">Prestigious Role & Badge</h3>
                                <p className="text-sm text-[#00ffe0] mb-4">Show off your Priority Hosting status with a special role and badge in our Discord server.</p>
                                <div className="h-1 w-16 bg-gradient-to-r from-[#00ffe0] to-[#00ccb3]"></div>
                            </div>

                            {/* Downtime Channel */}
                            <div className="bg-[#1A1A2E] p-6 rounded-lg border border-[#00ffe0] hover:border-[#00ffe0] transition-all">
                                <div className="text-[#00ffe0] text-2xl mb-4">⚠️</div>
                                <h3 className="text-xl font-bold text-white mb-2">Downtime Alerts</h3>
                                <p className="text-sm text-[#00ffe0] mb-4">Receive advance notifications of planned maintenance and real-time updates during any service interruptions.</p>
                                <div className="h-1 w-16 bg-gradient-to-r from-[#00ffe0] to-[#00ccb3]"></div>
                            </div>

                            {/* Staff Access Card */}
                            <div className="bg-[#1A1A2E] p-6 rounded-lg border border-[#00ffe0] hover:border-[#00ffe0] transition-all">
                                <div className="text-[#00ffe0] text-2xl mb-4">👥</div>
                                <h3 className="text-xl font-bold text-white mb-2">Exclusive Group Channels</h3>
                                <p className="text-sm text-[#00ffe0] mb-4">Access special Discord channels with direct communication to our staff team for priority assistance and feedback.</p>
                                <div className="h-1 w-16 bg-gradient-to-r from-[#00ffe0] to-[#00ccb3]"></div>
                            </div>

                            {/* Monthly Q&A Session Card */}
                            <div className="bg-[#1A1A2E] p-6 rounded-lg border border-[#00ffe0] hover:border-[#00ffe0] transition-all">
                                <div className="text-[#00ffe0] text-2xl mb-4">🗓️</div>
                                <h3 className="text-xl font-bold text-white mb-2">Monthly Q&A Sessions</h3>
                                <p className="text-sm text-[#00ffe0] mb-4">Join exclusive monthly Q&A sessions with our Staff Team and the Founder of BotGhost to get your questions answered directly.</p>
                                <div className="h-1 w-16 bg-gradient-to-r from-[#00ffe0] to-[#00ccb3]"></div>
                            </div>

                            {/* Performance Boosts Card */}
                            <div className="bg-[#1A1A2E] p-6 rounded-lg border border-[#00ffe0] hover:border-[#00ffe0] transition-all">
                                <div className="text-[#00ffe0] text-2xl mb-4">🚀</div>
                                <h3 className="text-xl font-bold text-white mb-2">Performance Boosts</h3>
                                <p className="text-sm text-[#00ffe0] mb-4">Revolutionary bot performance, uptime, and low latency with our premium infrastructure and optimized server configuration.</p>
                                <div className="h-1 w-16 bg-gradient-to-r from-[#00ffe0] to-[#00ccb3]"></div>
                            </div>

                            {/* Low Bot Density Card */}
                            <div className="bg-[#1A1A2E] p-6 rounded-lg border border-[#00ffe0] hover:border-[#00ffe0] transition-all">
                                <div className="text-[#00ffe0] text-2xl mb-4">⚙️</div>
                                <h3 className="text-xl font-bold text-white mb-2">Low Bot Density</h3>
                                <p className="text-sm text-[#00ffe0] mb-4">Only 10 bots per instance (down from 2000) ensuring your bots get dedicated resources and consistent performance.</p>
                                <div className="h-1 w-16 bg-gradient-to-r from-[#00ffe0] to-[#00ccb3]"></div>
                            </div>
                        </div>
                    </div>

                    {/* Stats Section */}
                    <div className="bg-gradient-to-r from-[#1A1A2E] to-[#1F2D2B] p-8 rounded-lg mb-16 border border-[#00ffe0]">
                        <SectionHeader title="The Priority Advantage" pretitle="By The Numbers" />
                        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mt-6">
                            <div className="text-center">
                                <div className="text-4xl font-bold text-[#00ffe0] mb-2">~10</div>
                                <div className="text-white text-lg">Bots Per Pod</div>
                                <p className="text-sm text-[#00ffe0] mt-2">Compared to 1-2 thousand on standard hosting</p>
                            </div>
                            <div className="text-center">
                                <div className="text-4xl font-bold text-[#00ffe0] mb-2">&lt;1 min</div>
                                <div className="text-white text-lg">Update Downtime</div>
                                <p className="text-sm text-[#00ffe0] mt-2">Compared to ~10 minutes on standard hosting</p>
                            </div>
                            <div className="text-center">
                                <div className="text-4xl font-bold text-[#00ffe0] mb-2">365</div>
                                <div className="text-white text-lg">Days of Storage</div>
                                <p className="text-sm text-[#00ffe0] mt-2">For buttons & menus vs. 30 days standard</p>
                            </div>
                            <div className="text-center">
                                <div className="text-4xl font-bold text-[#00ffe0] mb-2">32</div>
                                <div className="text-white text-lg">vCPU Cores</div>
                                <p className="text-sm text-[#00ffe0] mt-2">Graviton4 processors for maximum performance</p>
                            </div>
                        </div>
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-6">
                            <div className="text-center bg-[#1E1E30] p-4 rounded-lg">
                                <div className="text-3xl font-bold text-[#00ffe0] mb-2">128 GiB</div>
                                <div className="text-white text-lg">Memory</div>
                                <p className="text-sm text-[#00ffe0] mt-2">For seamless multi-tasking performance</p>
                            </div>
                            <div className="text-center bg-[#1E1E30] p-4 rounded-lg">
                                <div className="text-3xl font-bold text-[#00ffe0] mb-2">15 Gbps</div>
                                <div className="text-white text-lg">Network Speed</div>
                                <p className="text-sm text-[#00ffe0] mt-2">Ultra-low latency for real-time responses</p>
                            </div>
                            <div className="text-center bg-[#1E1E30] p-4 rounded-lg">
                                <div className="text-3xl font-bold text-[#00ffe0] mb-2">40,000</div>
                                <div className="text-white text-lg">IOPS</div>
                                <p className="text-sm text-[#00ffe0] mt-2">Blazing-fast database operations</p>
                            </div>
                        </div>
                    </div>

                    {/* Hardware Specifications Section */}
                    <div className="bg-gradient-to-br from-[#1A1A2E] to-[#1F2D2B] p-8 rounded-lg mb-16 border border-[#00ffe0]">
                        <SectionHeader title="Premium Hardware" pretitle="Our Technology" />
                        <div className="mt-6">
                            <div className="flex flex-col md:flex-row gap-8">
                                {/* Left column - Image/Icon */}
                                <div className="md:w-1/4 flex items-center justify-center">
                                    <div className="text-[#00ffe0] text-6xl p-8 bg-[#1E1E30] rounded-full border-2 border-[#00ffe0] shadow-lg">
                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-20 w-20" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M5 12h14M5 12a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v4a2 2 0 01-2 2M5 12a2 2 0 00-2 2v4a2 2 0 002 2h14a2 2 0 002-2v-4a2 2 0 00-2-2m-2-4h.01M17 16h.01" />
                                        </svg>
                                    </div>
                                </div>
                                {/* Right column - Specs */}
                                <div className="md:w-3/4">
                                    <h3 className="text-2xl font-bold text-white mb-4">AWS m8g.8xlarge Specifications</h3>
                                    <p className="text-[#00ffe0] mb-6">
                                        Our Priority Hosting runs on the latest AWS Graviton4 processors, delivering exceptional performance with ARM-based architecture specifically optimized for cloud workloads and advanced AI features.
                                    </p>

                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                                        <div className="bg-[#1E1E30] p-5 rounded-lg border border-[#00ffe0]">
                                            <h4 className="text-white font-medium mb-3">CPU Resources</h4>
                                            <ul className="space-y-3">
                                                <li className="flex justify-between">
                                                    <span className="text-[#00ffe0]">vCPUs:</span>
                                                    <span className="text-white font-medium">32</span>
                                                </li>
                                                <li className="flex justify-between">
                                                    <span className="text-[#00ffe0]">Processor:</span>
                                                    <span className="text-white font-medium">AWS Graviton4</span>
                                                </li>
                                                <li className="flex justify-between">
                                                    <span className="text-[#00ffe0]">Clock Speed:</span>
                                                    <span className="text-white font-medium">2.7 GHz</span>
                                                </li>
                                                <li className="flex justify-between">
                                                    <span className="text-[#00ffe0]">Architecture:</span>
                                                    <span className="text-white font-medium">ARM64</span>
                                                </li>
                                            </ul>
                                        </div>

                                        <div className="bg-[#1E1E30] p-5 rounded-lg border border-[#00ffe0]">
                                            <h4 className="text-white font-medium mb-3">Memory & Network</h4>
                                            <ul className="space-y-3">
                                                <li className="flex justify-between">
                                                    <span className="text-[#00ffe0]">Memory:</span>
                                                    <span className="text-white font-medium">128 GiB</span>
                                                </li>
                                                <li className="flex justify-between">
                                                    <span className="text-[#00ffe0]">Memory per vCPU:</span>
                                                    <span className="text-white font-medium">4 GiB</span>
                                                </li>
                                                <li className="flex justify-between">
                                                    <span className="text-[#00ffe0]">Network Bandwidth:</span>
                                                    <span className="text-white font-medium">15 Gbps</span>
                                                </li>
                                                <li className="flex justify-between">
                                                    <span className="text-[#00ffe0]">EBS Bandwidth:</span>
                                                    <span className="text-white font-medium">10,000 Mbps</span>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>

                                    <div className="bg-[#1E1E30] p-5 rounded-lg border border-[#00ffe0]">
                                        <h4 className="text-white font-medium mb-3">Why We Chose m8g.8xlarge</h4>
                                        <p className="text-[#00ffe0] mb-4">
                                            The AWS m8g.8xlarge instances represent the next generation of cloud computing power, offering unmatched performance for Discord bot hosting. With 8x the computing power and optimized for high-traffic applications, our priority servers deliver:
                                        </p>
                                        <ul className="space-y-2">
                                            <li className="flex items-start">
                                                <span className="text-[#00ffe0] text-lg mr-3">✓</span>
                                                <span className="text-white">Up to 40,000 IOPS for lightning-fast database operations</span>
                                            </li>
                                            <li className="flex items-start">
                                                <span className="text-[#00ffe0] text-lg mr-3">✓</span>
                                                <span className="text-white">Triple-digit concurrent operation processing</span>
                                            </li>
                                            <li className="flex items-start">
                                                <span className="text-[#00ffe0] text-lg mr-3">✓</span>
                                                <span className="text-white">Enhanced performance for resource-intensive bot features</span>
                                            </li>
                                            <li className="flex items-start">
                                                <span className="text-[#00ffe0] text-lg mr-3">✓</span>
                                                <span className="text-white">1,250 MB/s throughput for real-time data operations</span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* FAQ Section */}
                    <div className="mb-16">
                        <SectionHeader title="Frequently Asked Questions" pretitle="Priority Hosting" />
                        <div className="space-y-4 mt-8">
                            <div className="bg-[#1A1A2E] p-6 rounded-lg border border-[#00ffe0]">
                                <h3 className="text-xl font-bold text-white mb-2">What is Priority Hosting?</h3>
                                <p className="text-[#00ffe0]">
                                    Priority Hosting is our premium infrastructure tier that places your bots on exclusive high-performance servers with approximately 10 bots per pod (compared to 1,000-2,000 on standard hosting). This ensures faster response times, increased reliability, and enhanced capabilities for all your bots.
                                </p>
                            </div>

                            <div className="bg-[#1A1A2E] p-6 rounded-lg border border-[#00ffe0]">
                                <h3 className="text-xl font-bold text-white mb-2">Does Priority Hosting apply to all my bots?</h3>
                                <p className="text-[#00ffe0]">
                                    Yes! One of the biggest benefits of Priority Hosting is that a single subscription covers ALL your bots, not just one. This makes it extremely cost-effective for users with multiple bots.
                                </p>
                            </div>

                            <div className="bg-[#1A1A2E] p-6 rounded-lg border border-[#00ffe0]">
                                <h3 className="text-xl font-bold text-white mb-2">What happens during updates?</h3>
                                <p className="text-[#00ffe0]">
                                    With Priority Hosting, your bots experience significantly reduced downtime during platform updates. While standard servers might be offline for ~10 minutes, priority servers typically experience less than 1 minute of downtime. You'll also receive advance notifications in the exclusive downtime channel.
                                </p>
                            </div>

                            <div className="bg-[#1A1A2E] p-6 rounded-lg border border-[#00ffe0]">
                                <h3 className="text-xl font-bold text-white mb-2">What is the extended data retention benefit?</h3>
                                <p className="text-[#00ffe0]">
                                    Priority Hosting extends the database retention period for your buttons and select menus to a full 365 days without use. This means all your interactive components remain active and functional for an entire year, even if nobody clicks them. On standard hosting, these interactions expire after just 30 days which can break your bot's functionality if the buttons aren't regularly used. This extended storage ensures your bot's interactive elements always work as intended.
                                </p>
                            </div>

                            <div className="bg-[#1A1A2E] p-6 rounded-lg border border-[#00ffe0]">
                                <h3 className="text-xl font-bold text-white mb-2">What is alpha.botghost.com access?</h3>
                                <p className="text-[#00ffe0]">
                                    As a Priority Hosting subscriber, you'll gain exclusive access to our alpha testing environment where you can preview and test upcoming features before they're released to the public. You'll also have a say in how new features are implemented, providing direct feedback to our development team.
                                </p>
                            </div>

                            <div className="bg-[#1A1A2E] p-6 rounded-lg border border-[#00ffe0]">
                                <h3 className="text-xl font-bold text-white mb-2">What hardware powers Priority Hosting?</h3>
                                <p className="text-[#00ffe0]">
                                    Priority Hosting runs on AWS m8g.8xlarge instances, featuring powerful Graviton4 processors with 32 vCPUs and 128 GiB of memory. These ARM-based servers are specifically optimized for cloud workloads, providing up to 15 Gbps of network bandwidth and 10,000 Mbps of EBS bandwidth. This hardware configuration ensures your bots run with maximum efficiency and responsiveness, even during high-traffic periods.
                                </p>
                            </div>

                            <div className="bg-[#1A1A2E] p-6 rounded-lg border border-[#00ffe0]">
                                <h3 className="text-xl font-bold text-white mb-2">Why does Priority Hosting cost extra on top of a premium subscription?</h3>
                                <p className="text-[#00ffe0]">
                                    Priority Hosting is designed primarily for larger bot developers with bots in thousands of servers who need enterprise-grade performance and reliability. The significantly higher server costs of the AWS m8g.8xlarge instances with Graviton4 processors, combined with the drastically reduced bot density (only ~10 bots per instance vs 1-2 thousand), requires additional investment beyond our standard premium subscription. This specialized infrastructure ensures your high-traffic bots receive the dedicated resources, processing power, and reliability needed to serve large communities without performance degradation.
                                </p>
                            </div>

                            <div className="bg-[#1A1A2E] p-6 rounded-lg border border-[#00ffe0]">
                                <h3 className="text-xl font-bold text-white mb-2">How do I cancel my Priority Hosting subscription?</h3>
                                <p className="text-[#00ffe0]">
                                    You can cancel your Priority Hosting subscription at any time by clicking the "Manage Subscription" button above. This will take you to our subscription management portal where you can modify or cancel your subscription. If you cancel, your bots will continue to benefit from Priority Hosting until the end of your current billing cycle, at which point they will revert to standard hosting.
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* CTA Section */}
                    <div className="bg-gradient-to-br from-[#1E1E30] to-[#1F2D2B] rounded-xl p-8 text-center border border-[#00ffe0]">
                        <h2 className="text-3xl font-bold text-white mb-4">Ready to Upgrade Your Bots?</h2>
                        <p className="text-[#00ffe0] mb-8 max-w-2xl mx-auto">
                            Join our community of priority users today and experience the difference that dedicated hosting, extended features, and VIP access can make for your Discord bots. Priority Hosting is especially valuable for developers with high-traffic bots in thousands of servers who need enterprise-grade performance.
                        </p>
                        <button
                            onClick={this.props.user.prio_hosting ? handleSubscriptionManagement : this.upgrade}
                            className="py-3 px-8 bg-gradient-to-r from-[#00ffe0] to-[#00ccb3] hover:from-[#00ffe0] hover:to-[#00d9c4] text-black font-medium rounded-md transition-all transform hover:-translate-y-1 hover:shadow-lg">
                            {this.props.user.prio_hosting ? 'Manage Priority Hosting' : 'Upgrade to Priority Hosting'}
                        </button>
                    </div>
                </div>
            </Dashboard>
        );
    }
}

const mapStateToProps = (state) => ({
    user: state.data.user,
    auth: state.auth
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(PrioHosting);